import { render, staticRenderFns } from "./BridgeSpecialItemsView.vue?vue&type=template&id=774bbc7c"
import script from "./BridgeSpecialItemsView.vue?vue&type=script&lang=ts"
export * from "./BridgeSpecialItemsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports